// LUMINA · pages/vajra/utils.js
// Phase 39D: pure helper functions extracted from VajraPortal.jsx

import { TZ_OFFSETS, TZ_LABELS, GD } from './constants';

// Phase 33: timezone conversion
export function convertTime(timeStr, fromTz, toTz) {
  if (!timeStr || TZ_OFFSETS[fromTz]==null || TZ_OFFSETS[toTz]==null) return null;
  const [h, m] = timeStr.split(":").map(Number);
  const diff = TZ_OFFSETS[toTz] - TZ_OFFSETS[fromTz];
  let newH = h + diff;
  const cross = newH < 0 ? "（前日）" : newH >= 24 ? "（次日）" : "";
  newH = ((newH % 24) + 24) % 24;
  return `${String(Math.floor(newH)).padStart(2,"0")}:${String(m).padStart(2,"0")}${cross}`;
}

export function buildTimeRow(start_time, end_time, timezone) {
  if (!start_time || !timezone) return null;
  const fromLabel = TZ_LABELS[timezone] || timezone;
  const fromStr = end_time ? `${start_time}–${end_time} ${fromLabel}` : `${start_time} ${fromLabel}`;
  const targets = ["America/Vancouver","America/Toronto","Asia/Shanghai","Europe/London"].filter(tz=>tz!==timezone);
  const conversions = targets.map(tz=>{ const t=convertTime(start_time,timezone,tz); return t?`${t} ${TZ_LABELS[tz]||tz}`:null; }).filter(Boolean);
  return { fromStr, conversions };
}

// Helpers
export function today() { return new Date().toISOString().slice(0, 10); }
export function fmt(n) { return n >= 10000 ? (n/10000).toFixed(1)+"万" : n.toLocaleString(); }

export function getDaysInMonth(year, month) {
  return new Date(year, month+1, 0).getDate();
}
export function getFirstDayOfWeek(year, month) {
  return new Date(year, month, 1).getDay(); // 0=Sun
}

// Task 9: feeTag badge for events
export function feeTag(ev) {
  const dt = ev.donation_type;
  if (!dt || dt === "free")
    return { label:"免费", color:"#059669", bg:"rgba(5,150,105,0.08)", border:"rgba(5,150,105,0.25)" };
  if (dt === "donation")
    return { label:"随喜供养", color:GD, bg:"rgba(139,105,20,0.08)", border:"rgba(139,105,20,0.25)" };
  if (dt === "fixed" && ev.fee_amount)
    return { label:`$${(ev.fee_amount/100).toFixed(0)} CAD`, color:"#7c3aed", bg:"rgba(124,58,237,0.08)", border:"rgba(124,58,237,0.25)" };
  return null;
}
